// Global Types
import type {
  $Children,
} from 'common.types';

// Global Components
import * as React from 'react';

// Helpers
import {
  animationClass,
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  className?: string;
  fade?: boolean;
  small?: boolean;
};

type $Props = $OptionalProps & {
  children: $Children | null;
  loading: boolean;
};

type $State = {
  initialsed: boolean;
};

class LoaderView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    fade: undefined,
    small: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      initialsed: !props.loading,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      loading,
    } = this.props;

    if (loading === false && isDiff(
      loading,
      prevProps.loading,
    )) {
      this.setState({
        initialsed: true,
      });
    }
  }

  renderLoader() {
    const {
      fade,
      small,
    } = this.props;

    return (
      <div className={`absolute h-full w-full top-0 bottom-0 left-0 right-0 ${fade ? 'bg-white-tr rounded-lg' : ''} ${animationClass('fadeIn')}`}>
        <div className={'flex justify-center items-center w-full h-full'}>
          <div className={`${small === true ? '' : 'my-5'}`}>
            <div className={'lds-ring'}>
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      children,
      className,
      loading,
    } = this.props;
    const {
      initialsed,
    } = this.state;

    return (
      <div className={`relative ${className || ''} h-full min-h-3`}>
        {initialsed === true && children}
        {loading === true && this.renderLoader()}
      </div>
    );
  }
}

export default LoaderView;
